import React from 'react';
import {Redirect} from "react-router-dom";

import {observer} from 'mobx-react';
import {withStore} from "../../hocs";

// @ts-ignore
@withStore
@observer
export class RedirectAuthorizeIs extends React.Component {
    render() {
        // @ts-ignore
        const {store} = this.props;
        const {isAuth} = store?.mainStore;
        return (
            <>
                {isAuth ? null : <Redirect to="/login"/>}
            </>
        );
    }
}


